import { AuthApiService } from '@revenuewell/logic-http';
import { NavigationService } from '@revenuewell/logic-navigation';
import { OidcService } from '@revenuewell/logic-oidc';

export default class ProductService extends AuthApiService {
    private static instance: ProductService;
    private config: any;
    private productUrl: any;

    constructor(config: any, oidcService: OidcService) {
        super(oidcService, new NavigationService());
        this.config = config;
        this.productUrl = config.product.apiUrl;
    }

    public static getInstance(config: any, oidcService: OidcService) {
        if (!ProductService.instance) ProductService.instance = new ProductService(config, oidcService);

        return ProductService.instance;
    }

    getProductAvailability = async (locationId: number, product: string): Promise<boolean> => {
        const url = `${await this.productUrl}/product/IsProductAvailable?locationId=${locationId}&product=${product}`;
        const response = await this.authFetch(url, null, { ttlSeconds: 60 });

        return await response.json();
    };

    getAvailableProducts = async (locationId: number): Promise<string[]> => {
        const url = `${this.config.product.apiUrl}/Product/GetAvailableProducts?locationId=${locationId}`;
        const response = await this.authFetch(url, { method: 'GET' }, { ttlSeconds: 60 });
        return response.json();
    };
}
